/** transaction status
 * 0 : fail
 * 1 : Success
 * null : pending
 */

export const TransactionStatusCode = {
  SUCCESS: 1,
  FAILED: 0,
  PENDING: null,
} as const

export type TransactionStatus = typeof TransactionStatusCode[keyof typeof TransactionStatusCode]

type TransactionAddressInfo = {
  address: string
  nameTag: string
  isContract: boolean
}

export type Transaction = {
  status: TransactionStatus
  txHash: string
  method: string
  blockNumber: number
  blockTimestamp: number
  from: TransactionAddressInfo
  to: TransactionAddressInfo | null
  value: string
  txFee: string
  symbol: string
}

/** transaction detail */
export type TokenTransferList = {
  blockNumber: number
  blockTimestamp: number
  createdAt: string
  from: TransactionAddressInfo
  to: TransactionAddressInfo
  logIndex: number
  method: string
  name: string
  status: TransactionStatus
  symbol: string
  tokenImage: string
  value: string
}

export type TransactionDetailRes = {
  status: TransactionStatus
  txHash: string
  method: string
  blockTimestamp: number
  blockNumber: number
  from: TransactionAddressInfo
  to: TransactionAddressInfo | null
  tokenTransferList: TokenTransferList[]
  value: string
  txFee: string
  symbol: string
}

/** transaction list */
export type TransactionListRes = {
  totalPage: number
  totalTx: number
  transactionList: Transaction[]
}

export type AccountTransactionListRes = TransactionListRes
export type BlockTransactionListRes = TransactionListRes
